export default {"src":"/_next/static/media/lock.d0bcd986.svg","height":585,"width":585,"blurWidth":0,"blurHeight":0};